import { inject, Injectable, signal } from '@angular/core';
import { ServicePortalApi } from './api';
import { AuditIssue, Client, ClientListEntry, TestUser } from './types';


@Injectable()
export class StateService {
  api = inject(ServicePortalApi);

  isAdmin = signal(false);
  supportView = this.api.supportView;

  clients = signal<Client[]>([]);
  clientsLoading = signal(true);

  queryClients(callback?: () => void) {
    this.api.getManagedClients((value) => {
      for (const client of value.clients) {
        client.redirectUris.sort();
        client.webOrigins.sort();
      }

      this.clients.set(value.clients);
      this.clientsLoading.set(false);
      this.isAdmin.set(value.isServicePortalAdmin === true);
      if (callback) callback();
    });
  }

  lookupClient(id: string): Client | null {
    for (const client of this.clients()) {
      if (client.id === id) return client;
    }
    return null;
  }

  testUsers = signal<TestUser[]>([]);
  testUsersLoading = signal(true);

  queryTestUsers() {
    this.api.getTestUsers((list) => {
      this.testUsers.set(list.users);
      this.testUsersLoading.set(false);
    });
  }

  lookupTestUser(id: string): TestUser | null {
    for (const testUser of this.testUsers()) {
      if (testUser.id === id) return testUser;
    }
    return null;
  }

  clientList = signal<ClientListEntry[]>([]);
  clientListLoading = signal(true);

  queryClientList() {
    this.api.getClientList((list) => {
      this.clientList.set(list.clients);
      this.clientListLoading.set(false);
    });
  }

  clientIssues = signal<AuditIssue[]>([]);

  queryClientIssues() {
    this.api.getAudit(false, (result) => {
      this.clientIssues.set(result.issues);
    });
  }

}
